import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useContext } from "react";

import { ThemeProvider } from "@mui/material";

import { AppContext, ThemeMode } from "@context/context";
import MDXPageEN from "@portfolios/audinor/audinor_en.mdx";
import MDXPagePL from "@portfolios/audinor/audinor_pl.mdx";
import { embeddedDarkTheme, embeddedLightTheme } from "@themes/portfolio";

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

const ThemedPage = () => {
  const { locale } = useRouter();
  const appContext = useContext(AppContext);

  return (
    <>
      <ThemeProvider
        theme={
          appContext.theme === ThemeMode.Light
            ? embeddedLightTheme
            : embeddedDarkTheme
        }
      >
        {locale === "pl" ? <MDXPagePL /> : <MDXPageEN />}
      </ThemeProvider>
    </>
  );
};

export default function Audinor() {
  return <ThemedPage />;
}
